import { Injectable } from '@angular/core';
import { AuthService, AuthStatus } from '../api/auth.service';
import { ProfileService } from '../api/profile.service';
import { LocaleService } from './locale.service';

declare global {
  interface Window { fcWidget: any; }
}

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private _needToBeDestroyed = false;

  constructor(
    private localeService: LocaleService,
    private authService: AuthService,
    private profileService: ProfileService,
  ) {}

  show() {
    window.fcWidget?.show();
  }

  hide() {
    window.fcWidget?.hide();
  }

  init() {
    this.loadScript();
    this.updateUser();
  }

  destroy() {
    if (!window.fcWidget) {
      this._needToBeDestroyed = true;
    } else {
      window.fcWidget?.destroy();
    }
  }

  loadScript() {
    try {
      const scriptElement = document.createElement('script');
      scriptElement.async = true;
      scriptElement.src = `https://wchat.freshchat.com/js/widget.js`;
      scriptElement.onload = () => this.initChat();
      document.head.appendChild(scriptElement);
    } catch (e) {
      console.error('Error appending chat script');
      console.error(e);
    }
  }

  initChat() {
    if (this._needToBeDestroyed) {
      this._needToBeDestroyed = false;
      return;
    }
    
    window.fcWidget = window.fcWidget || {};

    window.fcWidget.init({
      token: "8c96d52c-9557-4467-8735-cd605dd36412",
      host: "https://wchat.freshchat.com",
      locale: this.localeService.currentLocale
    });
  }

  updateUser() {
    this.authService.statusChanges.subscribe(response => {
      if (response === AuthStatus.LoggedIn) {
        this.setUser();
      }
    });
  }

  setUser() {
    this.profileService.getGeneral().subscribe(response => {
      window.fcWidget.setExternalId(this.authService.getToken()?.userId || null);
      window.fcWidget.user.setFirstName(response.firstName);
      window.fcWidget.user.setLastName(response.lastName);
      window.fcWidget.user.setEmail(response.email);
    });
  }

  clearUser() {
    window.fcWidget.setExternalId(null);
    window.fcWidget.user.clear();
  }

}
